module.exports = __webpack_public_path__ + "img/black-used.2d6575e1.png";